import {clearSessionToken} from './token'
import {clearSessionPartnerId} from './partnerID'

export default (location, url) => {
  clearSessionToken()
  clearSessionPartnerId()

  url = url || 'http://creditsafe.com'
  location.replace(url)
}



// WEBPACK FOOTER //
// ./src/logout.js